import styled from 'styled-components';
import { s } from './NPL.styles';
import { NumberwithComma, ReportFormatNumber } from '../../../../func/Function';
import { INplInfo } from '../../../../service/detail/Detail';

interface IRealEstateStatusProps {
  info: INplInfo;
}

const RealEstateStatus = (props: IRealEstateStatusProps) => {
  const { info } = props;
  return (
    <s.Div>
      <s.Title>부동산 현황</s.Title>
      <s.Table>
        <s.TableRow>
          <s.RowCategory>물건종류</s.RowCategory>
          <s.RowContent>{info.itemcatetory}</s.RowContent>
        </s.TableRow>
        <s.TableRow>
          <s.RowCategory>사용승인일</s.RowCategory>
          <s.RowContent>
            {info.approval_date?.split(' ')[0].replaceAll('-', '.')}
          </s.RowContent>
        </s.TableRow>
        <s.TableRow>
          <s.RowCategory>용도지역</s.RowCategory>
          <s.RowContent>{info.zoning}</s.RowContent>
        </s.TableRow>
        <s.TableRow>
          <s.RowCategory>토지면적</s.RowCategory>
          <s.RowContent>
            {Number(info.landarea) !== 0 && !Number(info.landarea)
              ? '-'
              : ReportFormatNumber(info.landarea, true, false) +
                'm² (' +
                ReportFormatNumber(
                  Number(info.landarea) / 3.3058,
                  true,
                  false,
                ) +
                '평)'}
            {/* 000.0m²(0000.0평) */}
          </s.RowContent>
        </s.TableRow>
        <s.TableRow>
          <s.RowCategory>건물면적</s.RowCategory>
          <s.RowContent>
            {info.buildingarea.trim() === ''
              ? ''
              : Number(info.buildingarea) !== 0 && !Number(info.buildingarea)
                ? '-'
                : ReportFormatNumber(info.buildingarea, true, false) +
                  'm² (' +
                  ReportFormatNumber(
                    Number(info.buildingarea) / 3.3058,
                    true,
                    false,
                  ) +
                  '평)'}
            {/* 000.0m²(0000.0평) */}
          </s.RowContent>
        </s.TableRow>
        <s.TableRow>
          <s.RowCategory>층수</s.RowCategory>
          <s.RowContent>{info.floor}</s.RowContent>
        </s.TableRow>
      </s.Table>
    </s.Div>
  );
};

export default RealEstateStatus;
